import { createSelector } from 'reselect';
import { IAppState, TInlineAlert } from '../types/state.d';

export const appSelector = (state: IAppState) => state.app;

export const getIsAnyCharityAllowed = createSelector(appSelector, app =>
  Boolean(app.yourFundraisingCause.allowAnyCharity),
);

export const getIsOwnEventAllowed = createSelector(appSelector, app =>
  Boolean(app.yourFundraisingCause.allowOwnEvent),
);

export const getIsInviteLinkCopied = createSelector(
  appSelector,
  app => app.isInviteLinkCopied,
);
export const getIsFatalError = createSelector(
  appSelector,
  app => app.isFatalError,
);

export const getSelectedFundraisingPage = createSelector(
  appSelector,
  app => app.selectedFundraisingPage,
);

export const getInlineAlert = createSelector(
  appSelector,
  (app: IAppState['app']): TInlineAlert => app.inlineAlert,
);

export const getFrpId = createSelector(appSelector, app => app.frpId);

export const getNewFrpData = createSelector(appSelector, app => app.newFrpData);

export const getSelectedEvent = (state: IAppState) =>
  appSelector(state).selectedEvent;

export const getSelectedCause = (state: IAppState) =>
  appSelector(state).selectedCause;
